<template>
  <div v-if="IsVerified || User.info.migrated">
    <sub-menu
      :title="title"
      :routes="routes"
    ></sub-menu>

    <router-view></router-view>
  </div>
  <div v-else>
    <div class="px-2 lg:px-0 mt-24 md:mt-0">
      <p class="font-display text-2xl font-bold mb-4 text-gray-900 ltr:pl-5 ltr:lg:pl-0 rtl:pr-5 rtl:lg:pr-0">{{ $t("transactions").tTitle() }}</p>
      <div class="h-[74vh] mt-6 pt-5 bg-white rounded-lg shadow-ts1 flex flex-col justify-center items-center px-5 lg:px-0">
        <div v-if="IsDemo">
          <img src="../../assets/img/upgrade-to-live.svg" width="115" class="mx-auto mb-10"/>
          <p class="max-w-[450px] mx-auto text-gray-900 text-base text-center mb-10">{{ $t('upgrade_to_live_text') }}</p>
          <router-link
            :to="'/' + Language + '/register/upgrade'"
            class="bg-green text-white text-center text-base font-bold py-3 rounded-md w-48 table cursor-pointer mx-auto"
          >
            {{$t("upgrade_to_live").tTitle()}}
          </router-link>
        </div>
        <div v-if="IsLive">
          <img src="../../assets/img/upload-your-documents.svg" width="115" class="mx-auto mb-10"/>
          <p class="max-w-[500px] mx-auto text-gray-900 text-base text-center mb-10">{{ $t('upload_your_documents_text') }}</p>
          <router-link
            :to="'/' + Language + '/profile/upload-documents'"
            class="bg-blue text-white text-center text-base font-bold py-3 rounded-md px-5 table cursor-pointer mx-auto"
          >
            {{$t("upload_your_documents").tTitle()}}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubMenu from '@/components/SubMenu.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      title: 'transactions',
      routes: [
        { path: '/finance', title: 'deposit' },
        { path: '/finance/withdraw', title: 'withdrawal' },
        { path: '/finance/internal-transfer', title: 'internal_transfer' },
        { path: '/finance/payment-history', title: 'payment_history' },
        { path: '/finance/my-bonuses', title: 'bonuses' },
      ],
    }
  },
  components: {
    SubMenu,
  },
  computed: {
    checkForMigrated() {
      return this.IsVerified, this.User.info.migrated, this.Menu
    },
    ...mapGetters({
      Language: 'language/code',
      IsLive: 'user/isLive',
      IsDemo: 'user/isDemo',
      IsVerified: 'user/isVerified',
      BonusConfig: 'bonusconfig/all',
      User: 'user/all',
      Menu: 'menu/all',
    }),
  },
  watch: {
    /**
     * Check for migrated users in order to place the upload button accordingly.
     */
    checkForMigrated() {
      // check for no migrated users to change the placement of the upload documents button
      if (!this.IsVerified && !this.User.info.migrated && this.Menu) {
        this.Menu[0].children.forEach((menuItem, index) => {
          if(menuItem.path === 'finance') {
            this.Menu[0].children[index].meta.usesSubMenuItems = false
            this.Menu[0].children[index].children[0].meta.usesSubMenuItems = false
            menuItem.meta.usesSubMenuItems = false
          }
        });
      }
    }
  },
  methods: {
    ...mapActions(['logoLoader/set']),
  }
}
</script>

